import { defineComponent as _defineComponent } from 'vue'
import { useConfigStore, useLocationStore } from '@/store';
import { AreaKey } from '@/types/area';
import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';

// store

export default /*#__PURE__*/_defineComponent({
  __name: 'area-recommend',
  setup(__props) {

const { currentAreaRecommendAreaList } = storeToRefs(useConfigStore());
const { setArea } = useLocationStore();

function changeArea(key: AreaKey) {
  setArea(key);
  nextTick(() => {
    // 滚动到顶部
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });
}

return { __sfc: true,currentAreaRecommendAreaList, setArea, changeArea }
}

})